import { defineMessages } from 'react-intl';
import type { IntlShape } from 'react-intl';

const messages = defineMessages({
  blockTitle: {
    id: 'Photo Mosaic',
    defaultMessage: 'Photo Mosaic',
  },
  contentFieldset: {
    id: 'Content',
    defaultMessage: 'Content',
  },
  images: {
    id: 'Images',
    defaultMessage: 'Images',
  },
  imagesDescription: {
    id: 'photoMosaic.imagesDescription',
    defaultMessage:
      'Add exactly 11 images: 5 for the first row and 6 for the second row. Fewer images will leave gaps; extra images will not be displayed.',
  },
  image: {
    id: 'Image',
    defaultMessage: 'Image',
  },
  altText: {
    id: 'Alt text',
    defaultMessage: 'Alt text',
  },
});

export const ImageItemSchema = ({ intl }: { intl: IntlShape }) => ({
  title: intl.formatMessage(messages.image),
  fieldsets: [
    {
      id: 'default',
      title: intl.formatMessage(messages.contentFieldset),
      // `size` removido: o design não tem tiles grandes/pequenos —
      // todos uniformes (spec photo-mosaic.md §12.2)
      fields: ['image', 'alt'],
    },
  ],
  properties: {
    image: {
      title: intl.formatMessage(messages.image),
      widget: 'image',
    },
    alt: {
      title: intl.formatMessage(messages.altText),
      type: 'string',
    },
  },
  required: [],
});

/**
 * Schema do bloco Photo Mosaic.
 * Grid responsivo com imagens de tamanhos variáveis.
 * Ver docs/specs/schema-decisions.md §5.
 */
const PhotoMosaicSchema = ({ intl }: { intl: IntlShape }) => ({
  title: intl.formatMessage(messages.blockTitle),
  fieldsets: [
    {
      id: 'default',
      title: intl.formatMessage(messages.contentFieldset),
      fields: ['images'],
    },
  ],
  properties: {
    images: {
      title: intl.formatMessage(messages.images),
      description: intl.formatMessage(messages.imagesDescription),
      widget: 'object_list',
      schema: ImageItemSchema({ intl }),
    },
  },
  required: [],
});

export default PhotoMosaicSchema;
